import { render, staticRenderFns } from "./TopUpWallet.vue?vue&type=template&id=10678351&"
import script from "./TopUpWallet.vue?vue&type=script&lang=js&"
export * from "./TopUpWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports